import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, Container, Stack, Typography, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { NewsUpdatePage, NewsPage } from '../sections/@dashboard/newsUpdate';

const StyledCard = styled('div')(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]         
      : theme.palette.background.paper, 

  padding: theme.spacing(2.5),
  borderRadius: 20,

  boxShadow:
    theme.palette.mode === 'light'
      ? '0px 0px 10px rgba(0, 0, 0, 0.15)'
      : '0px 0px 10px rgba(0, 0, 0, 0.6)',
}));

export default function NewsUpdate() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const navigate = useNavigate();

  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
    navigate('/dashboard/news-update');
  };

  return (
    <>
      <Helmet>
        <title>News Update | WatchNod</title>
        <meta
          name="description"
          content="Stay updated with the latest news reports on WatchNod. Add, edit, and view news updates seamlessly."
        />
        <meta name="keywords" content="news updates, latest news, WatchNod news, news management, news platform" />
        <meta name="author" content="WatchNod Team" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <h1>
            <Typography variant="h3" gutterBottom>
              News Report Update
            </Typography>
          </h1>
          <Button variant="contained" onClick={openForm}>
            Add News
          </Button>
        </Stack>
        <NewsPage openForm={openForm} key={reloadData} />

        <Dialog open={isFormOpen} onClose={closeForm}>
          <StyledCard>
            <NewsUpdatePage closeForm={closeForm} reloadData={() => setReloadData(!reloadData)} />
          </StyledCard>
        </Dialog>
      </Container>
    </>
  );
}
